import { Link } from "react-router-dom";
import BrandMark from "@/components/app/BrandMark";

export function PublicNav() {
  return (
    <header className="sticky top-0 z-40 border-b border-slate-200/70 bg-white/70 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <BrandMark />
        <nav className="hidden md:flex items-center gap-8">
          <Link to="/tentang" className="text-sm font-medium text-slate-600 hover:text-emerald-600 transition-colors" data-testid="nav-about">Tentang Inovasi</Link>
          <Link to="/fitur" className="text-sm font-medium text-slate-600 hover:text-emerald-600 transition-colors" data-testid="nav-features">Fitur</Link>
          <Link to="/panduan" className="text-sm font-medium text-slate-600 hover:text-emerald-600 transition-colors" data-testid="nav-guide">Panduan</Link>
          <Link to="/kontak" className="text-sm font-medium text-slate-600 hover:text-emerald-600 transition-colors" data-testid="nav-contact">Kontak</Link>
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/login" className="gc-btn-primary text-sm" data-testid="nav-login">Masuk ke Sistem</Link>
        </div>
      </div>
    </header>
  );
}

export function PublicFooter() {
  return (
    <footer className="mt-24 border-t border-slate-200 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <BrandMark />
          <p className="mt-4 text-sm text-slate-500 max-w-md leading-relaxed">
            <span className="font-semibold text-slate-700">GREENCON HPP</span> — Sistem Informasi Akuntansi Harga Pokok Produksi Beton Rendah Karbon. <strong>Produk inovasi Politeknik Negeri Manado</strong> yang dikembangkan dari hasil penelitian dan dihilirisasikan kepada industri konstruksi.
          </p>
        </div>
        <div>
          <p className="gc-label">Navigasi</p>
          <ul className="mt-3 space-y-2 text-sm text-slate-600">
            <li><Link to="/tentang" className="hover:text-emerald-600">Tentang Inovasi</Link></li>
            <li><Link to="/fitur" className="hover:text-emerald-600">Fitur</Link></li>
            <li><Link to="/panduan" className="hover:text-emerald-600">Panduan</Link></li>
            <li><Link to="/kontak" className="hover:text-emerald-600">Kontak</Link></li>
          </ul>
        </div>
        <div>
          <p className="gc-label">Pengembang Sistem</p>
          <ul className="mt-3 space-y-2 text-sm text-slate-600">
            <li className="font-semibold text-slate-800">Politeknik Negeri Manado</li>
            <li className="text-xs text-slate-500">Tim Peneliti & Pengabdian Masyarakat</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200 py-5 text-center text-xs text-slate-500">© {new Date().getFullYear()} GREENCON HPP • Politeknik Negeri Manado — Perhitungan biaya yang akurat, transparan, dan berkelanjutan.</div>
    </footer>
  );
}
